function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 8,
  fill: "#1A8E96"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.45 9.675l2.85-2.85-.525-.512L7.487 8.6 6.226 7.338l-.55.55L7.45 9.675zM8 13c-1.167-.292-2.125-.969-2.875-2.031C4.375 9.906 4 8.742 4 7.475V4.5L8 3l4 1.5v2.975c0 1.267-.375 2.431-1.125 3.494C10.125 12.03 9.167 12.709 8 13zm0-.775c.958-.317 1.74-.915 2.344-1.794a5.1 5.1 0 00.906-2.956v-2.45L8 3.8 4.75 5.025v2.45a5.1 5.1 0 00.906 2.956c.604.88 1.386 1.477 2.344 1.794z",
  fill: "#fff"
});

function SvgWarrantyNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgWarrantyNew;